import CloseContainer from 'components/shared/close-container';
import SearchIcon from 'components/shared/searchIcon';
import { useUI } from 'contexts/UIContext';
import Icon from 'components/shared/icon';
import { useSalonSearch } from 'hooks';
import { useGlobalModules } from 'contexts';
import styles from './salonSelectorModal.module.scss';

export default function SalonSelectorModal({ locale, customCallback }) {
  const { displaySalonSelector, closeSalonSelector } = useUI();
  const globalModules = useGlobalModules();
  const { salonSelector } = globalModules?.translations;

  const {
    filteredSalons,
    searchQuery,
    setSearchQuery,
    selectedSalon,
    setSelectedSalon,
    loading,
    confirmSelection,
    showingNearest,
  } = useSalonSearch({ locale, isOpen: displaySalonSelector });

  if (!displaySalonSelector) return null;

  return (
    <div className={styles.modalShadow}>
      <div className={styles.salonSelectorModal}>
        <button className={styles.closeButton} type="button" onClick={closeSalonSelector}>
          <CloseContainer width="1.2rem" height="1.2rem" />
        </button>
        <p className={styles.selectSalonText}>{salonSelector.selectAmbassadorSalon}</p>
        <p className={styles.salonChoiceDescription}>{salonSelector.salonChoiceDescription}</p>
        <div className={styles.searchBarWrapper}>
          <SearchIcon />
          <input
            className={styles.searchBar}
            type="text"
            value={searchQuery}
            placeholder={salonSelector.searchPlaceholder}
            onChange={e => setSearchQuery(e.target.value)}
          />
        </div>
        <div className={styles.optionsView}>
          {loading && <Icon className={styles.loadingIcon} type="loading" />}

          {!loading && showingNearest && salonSelector?.showingNearestSalons && (
            <p className={styles.nearestHint}>{salonSelector.showingNearestSalons}</p>
          )}
          {!loading && (
            <div className={styles.salonOptions}>
              {filteredSalons.map(salon => (
                <SalonOption
                  salon={salon}
                  key={salon.salonNo}
                  selected={selectedSalon?.salonName === salon.salonName}
                  setSelected={() => setSelectedSalon(salon)}
                />
              ))}
            </div>
          )}
        </div>
        <div className={styles.buttonsSection}>
          <button
            className={styles.confirmChoice}
            type="button"
            onClick={() =>
              confirmSelection(salon => {
                closeSalonSelector();
                if (customCallback) {
                  customCallback(salon);
                }
              })
            }
          >
            {salonSelector.confirmChoice}
          </button>
          <button className={styles.cancelAction} type="button" onClick={closeSalonSelector}>
            {salonSelector.cancelSelection}
          </button>
        </div>
      </div>
    </div>
  );
}

/** A singular salon option presented in the salon selector modal */
const SalonOption = ({ salon, selected, setSelected }) => (
  <div
    className={styles.salonOption}
    tabIndex={0}
    role="option"
    aria-selected={selected}
    onClick={setSelected}
    onKeyDown={setSelected}
  >
    <input className={styles.salonCheckbox} type="radio" checked={selected} onChange={() => {}} />
    <div className={styles.salonInfo}>
      <p className={styles.salonName}>
        {salon.formattedDistance ? `${salon.formattedDistance} KM - ` : ''}
        {salon.salonName}
      </p>
      {(salon.AddressLine2 || salon.city) && (
        <p className={styles.salonAddress}>
          {[salon.AddressLine2, salon.city].filter(Boolean).join(', ')}
        </p>
      )}
    </div>
  </div>
);
